import { useEffect, useRef } from "react";
import ActionRow from "../components/v2/ActionRow";
import PageTransition from "../components/v2/PageTransition";
import QuestionCounter from "../components/v2/QuestionCounter";
import QuestionLabel from "../components/v2/QuestionLabel";
import TextInput from "../components/v2/TextInput";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export default function TextQuestionSurface({
  current,
  label,
  placeholder,
  errorCopy,
  name,
  value,
  error,
  direction = "forward",
  autoCapitalize = "sentences",
  spellCheck = "true",
  editMode = false,
  onChange,
  onBlur,
  onBack,
  onNext,
}) {
  const inputRef = useRef(null);
  const errorId = `surface-${current}-error`;

  useEffect(() => {
    const reduceMotion =
      typeof window !== "undefined" &&
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const timer = window.setTimeout(() => {
      inputRef.current?.focus();
    }, reduceMotion ? 200 : 360);

    return () => window.clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (error) inputRef.current?.focus();
  }, [error]);

  const nextDisabled = !String(value || "").trim();

  return (
    <section className="tgc-v2-surface" aria-labelledby="question-label">
      <PageTransition direction={direction}>
        <div className="tgc-v2-content">
          <Wordmark variant="stacked" />
          <QuestionCounter current={current} total={12} />
          <QuestionLabel>{label}</QuestionLabel>

          <div className="tgc-v2-field-wrap">
            <TextInput
              ref={inputRef}
              value={value}
              error={error}
              type="text"
              variant="left-aligned"
              name={name}
              autoComplete="off"
              inputMode="text"
              enterKeyHint="next"
              autoCapitalize={autoCapitalize}
              spellCheck={spellCheck}
              maxLength={100}
              placeholder={placeholder}
              aria-labelledby="question-label"
              aria-describedby={error ? errorId : undefined}
              onChange={(event) => onChange(event.target.value)}
              onBlur={onBlur}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  onNext();
                }
              }}
            />
            <div className="tgc-v2-error" id={errorId} aria-live="polite">
              {error ? errorCopy : ""}
            </div>
          </div>

          <ActionRow
            variant={editMode ? "done-only" : "two-button"}
            onBack={onBack}
            onNext={onNext}
            nextDisabled={nextDisabled}
            nextLabel={editMode ? "Done" : "Next"}
          />
        </div>
      </PageTransition>
    </section>
  );
}
